import { Button, Card, Col, Container, Row } from "react-bootstrap";
import photo from './../../photos/1.png';
import './sectionTow.css';
function SectionTow(){
    return(
        <section id="section-tow">
            <Container>
                <Row id="main">
                    <Col lg={7}>
                    <Card.Img id="imge" src={photo} />
                    </Col>
                    <Col>
                        <h3>
                        We pride ourselves on making real food from the best ingredients.
                        </h3>
                        <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat tellus.
                        </p>
                        <Button id="section-tow-btn">Learn More</Button>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default SectionTow;